import accessibilitySubCategory from './accessibilitySubCategory';
import accountSubCategory from './accountSubCategory';
import appearanceSubCategory from './appearanceSubCategory';
import advertisingSubCategory from './advertisingSubCategory';
import categoriesSubCategory from './categoriesSubCategory';
import privacySubCategory from './privacySubCategory';
import mobileSubCategory from './mobileSubCategory';
import notificationsSubCategory from './notificationsSubCategory';
import premiumDashboardSubCategory from './premiumDashboardSubCategory';
import storageSubCategory from './storageSubCategory';
import { ControlIcons } from 'owa-control-icons';
import { OptionCategory } from 'owa-options-core';

let generalCategory: OptionCategory = {
    key: 'general',
    titleStringKey: 'optionCategory_General',
    icon: ControlIcons.Settings,
    subcategories: [
        accountSubCategory,
        appearanceSubCategory,
        notificationsSubCategory,
        categoriesSubCategory,
        accessibilitySubCategory,
        premiumDashboardSubCategory,
        mobileSubCategory,
        storageSubCategory,
        privacySubCategory,
        advertisingSubCategory,
    ],
};

export default generalCategory;
